import { Box } from '@cmpsr/components';
import CheckBullet from '../ppra-results-page/components/check-bullet/CheckBullet';

const MembershipBenefits = ({ color = 'darkBlue' }: { color?: string }) => {
  const benefits = [
    '**Comprehensive Risk Assessment** covering 500+ verified risk factors',
    '**Lifetime Risk Scores** for 21 major cancer types',
    '**Annual Screening Protocols** for every cancer based on your risk',
    '**Personalized Action Plan** to reduce your risk up to 60%',
    '**Member-only Updates** on cancer prevention research and strategies',
  ];

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" width="100%" gap="3">
      {benefits.map((benefit, index) => (
        <CheckBullet key={index} color={color}>
          {benefit}
        </CheckBullet>
      ))}
    </Box>
  );
};

export default MembershipBenefits;
